export function SidebarDivider() {
  return <div className="border-t w-full"></div>;
}
